var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-component"},[_c('Head',{staticClass:"head-wrapper"}),_c('Main',{staticClass:"main-wrapper"}),_c('Foot',{staticClass:"foot-wrapper"}),_c('Tool',{staticClass:"tool-wrapper"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }